import React from 'react';
import { PositionAngle, ShelfComposition } from 'lib/modelBuilder/constants';
import { HandleUserSelection } from 'containers/HandlesPanel/types';
import {
  getHandleDoorColorOfSelectedShelves,
  isHandleDoorOfSelectedShelvesPresent,
} from 'containers/HandlesPanel/utils';
import { Shelf } from 'lib/modelBuilder/entities/Shelf';
import { useTranslation } from 'react-i18next';
import GenericObjectSelector, {
  SelectorSize,
} from 'components/GenericObjectSelector';
import AllSelector from '../../../components/AllSelector';

interface Props {
  handlePositionSelected: HandleUserSelection[];
  selectedShelves: Shelf[];
  selection: any;
  compositions: Set<ShelfComposition>;
  handleSelection: any;
  doorPositions: PositionAngle[];
  largeDoors: boolean;
  allSelector: boolean;
  selectAll?: any;
}

const DoorsHandlesSelection = ({
  handlePositionSelected,
  selectedShelves,
  selection,
  handleSelection,
  doorPositions,
  largeDoors,
  allSelector,
  selectAll,
}: Props) => {
  const { t } = useTranslation();
  function getTitle(pos: PositionAngle) {
    switch (pos) {
      case PositionAngle.FrontLeft:
        return t('Left');
      case PositionAngle.FrontRight:
        return t('Right');
      case PositionAngle.BackLeft:
        return t('Back left');
      case PositionAngle.BackRight:
        return t('Back right');
    }
  }

  return (
    <>
      <div className="flex justify-center py-1 flex-wrap">
        {doorPositions.map(pos => (
          <GenericObjectSelector
            key={pos}
            title={getTitle(pos)}
            selected={handlePositionSelected.includes(pos)}
            color={getHandleDoorColorOfSelectedShelves(pos, selectedShelves)}
            onClick={(e: any) => selection(e, pos)}
            present={isHandleDoorOfSelectedShelvesPresent(pos, selectedShelves)}
            canAddNew={false}
            rounded
            size={
              doorPositions.length <= 2
                ? SelectorSize.medium
                : SelectorSize.small
            }
            showMaterial={false}
            showColor={!largeDoors}
          />
        ))}
        {allSelector && selectAll && (
          <div className="flex justify-center items-center">
            <AllSelector onClick={selectAll} className="mx-2 ">
              {t('All')}
            </AllSelector>
          </div>
        )}
      </div>
    </>
  );
};

export default DoorsHandlesSelection;
